import { capitalizeFirstLetter } from "src/utils/methods";
import { addHeaderToArray } from "../../addHeaderToArray";

const SENTIMENT_NAMES = ["positive", "neutral", "negative"];

export const addSelectedCommentsToGridElements = (
  newGridElements,
  newHiddenGridElements,
  savedTemplate,
  templateApplied,
  campaigns,
  aggregation,
  formatMessage,
  campaignId,
  comments,
) => {
  if (!comments) return;

  const isSuitableForSelectedMode =
    (aggregation && campaignId !== "aggregated") ||
    (!aggregation && campaignId === "aggregated");

  const isSingleCampaign = Object.keys(campaigns).length === 1;
  const headerDepth = campaignId !== "aggregated" && !isSingleCampaign ? 3 : 2;

  addHeaderToArray(
    formatMessage({
      id: "ws_selected_comments",
      defaultMessage: "Selected comments",
    }),
    !isSuitableForSelectedMode ? newGridElements : newHiddenGridElements,
    headerDepth,
    `comments-${campaignId}`,
    savedTemplate,
    templateApplied,
    "comments",
  );

  Object.keys(comments?.all).forEach((key) => {
    const name = SENTIMENT_NAMES.includes(key) ? `${key} sentiment` : key;

    const element = {
      key: `${key}-${campaignId}`,
      commentList: comments?.all[key] || [],
      label: `comments-${key}-${campaignId}`,
      provider: "comments",
      name: capitalizeFirstLetter(name),
      gridBoxType: "comments",
      section: `comments-${campaignId}`,
      campaignId,
    };

    // applying saved template

    if (
      (!aggregation && campaignId === "aggregated") ||
      (aggregation && campaignId !== "aggregated")
    ) {
      newHiddenGridElements.push(element);
    } else if (savedTemplate?.length && !templateApplied) {
      if (savedTemplate.find((item) => item.i === element.label)) {
        newGridElements.push(element);
      } else {
        newHiddenGridElements.push(element);
      }
    } else {
      newGridElements.push(element);
    }
  });
};
